var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/Banking.vue": 56,
	"./frontend/BetslipHistory.vue": 5884,
	"./frontend/BodyFB.vue": 3375,
	"./frontend/Commission.vue": 5372,
	"./frontend/ContactUs.vue": 5093,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 4603,
	"./frontend/History.vue": 5245,
	"./frontend/Home.vue": 3805,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Iframe copy.vue": 3020,
	"./frontend/Iframe.vue": 9898,
	"./frontend/Index.vue": 9165,
	"./frontend/Live.vue": 6030,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 4694,
	"./frontend/MatchResult.vue": 972,
	"./frontend/MaungFB.vue": 4917,
	"./frontend/Promotion.vue": 6518,
	"./frontend/Setting.vue": 7088,
	"./frontend/VideoLink.vue": 1068,
	"./frontend/VipLevels.vue": 6997,
	"./frontend/Withdraw.vue": 4041,
	"./frontend/auth/Login.vue": 252,
	"./frontend/auth/Register.vue": 4281,
	"./frontend/auth/Rule.vue": 2251,
	"./frontend/auth/Verify.vue": 1581,
	"./frontend/auth/VerifyNotAuth.vue": 2739,
	"./frontend/components/AccountSelect.vue": 6311,
	"./frontend/components/AppHeader.vue": 2221,
	"./frontend/components/DataTable.vue": 3935,
	"./frontend/components/FBPreviewVoucher.vue": 8502,
	"./frontend/components/FBVoucher.vue": 4438,
	"./frontend/components/FootballTeamCard.vue": 8838,
	"./frontend/components/GroupBox.vue": 3593,
	"./frontend/components/InputSelectDrawModal.vue": 7621,
	"./frontend/components/LuckyWheel.vue": 4223,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 8096,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 326,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 8796,
	"./frontend/components/Voucher.vue": 9247,
	"./frontend/normal-user/2d/2d.vue": 3804,
	"./frontend/normal-user/2d/ClosedDays.vue": 2083,
	"./frontend/normal-user/2d/Home.vue": 3034,
	"./frontend/normal-user/2d/Winner.vue": 24,
	"./frontend/normal-user/3d/3d.vue": 4308,
	"./frontend/normal-user/3d/Home.vue": 9750,
	"./frontend/normal-user/DreamBooks.vue": 6547,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 9666,
	"./frontend/normal-user/game/Arcade.vue": 8662,
	"./frontend/normal-user/game/Fishing.vue": 1791,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 4368,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;